import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, Spin } from 'antd'

// TOTP QR 내보내기 모달(PR9 #1535) — otpauth URI 를 QR 로 렌더해 폰 인증 앱이
// 스캔하게 한다. QR = 인증 키 원본이므로:
// - 렌더는 createDataURL(GIF data URI)→<img> — svg DOM 삽입(dangerouslySetInnerHTML)
//   자체를 하지 않아 XSS 표면이 없다(설계 §5.5 Gemini 수용).
// - destroyOnClose 로 닫는 즉시 DOM 에서 파기, URI/secret 은 로그에 남기지 않는다.
// - qrcode-generator(무의존 CJS)는 동적 import — 기능 미사용 시 로드되지 않는다.
const TotpQrModal = ({ open, uri, title, onClose }) => {
  const { t } = useTranslation()
  const [dataUrl, setDataUrl] = useState(null)
  const [error, setError] = useState(false)

  useEffect(() => {
    // 초기화를 조건보다 먼저 — 열린 상태에서 uri 가 바뀌거나 null 이 되어도
    // 이전 QR 이 잔존하지 않도록(PR #1537 리뷰)
    setDataUrl(null)
    setError(false)
    if (!open || !uri) return undefined
    let cancelled = false
    ;(async () => {
      try {
        const mod = await import('qrcode-generator')
        const qrcode = mod.default || mod
        const qr = qrcode(0, 'M') // typeNumber 0 = 데이터 길이에 맞춰 자동
        qr.addData(uri)
        qr.make()
        if (!cancelled) setDataUrl(qr.createDataURL(6, 8))
      } catch (e) {
        // 생성 실패 사유/URI 는 로그 금지(secret 원본) — 에러 상태만 표시
        if (!cancelled) setError(true)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [open, uri])

  const renderQrBody = () => {
    if (error || (open && !uri)) return <p>{t('record.totp.invalid')}</p>
    if (dataUrl) {
      return (
        <img
          src={dataUrl}
          alt={t('record.totp.qrTitle', { title })}
          // 크기 강제 다운스케일 시 보간 blur 로 스캔 성공률이 떨어질 수 있어(리뷰)
          // 네이티브 해상도 유지 + 축소가 불가피한 좁은 화면에서는 pixelated 보간
          style={{ maxWidth: '100%', imageRendering: 'pixelated' }}
        />
      )
    }
    return <Spin />
  }

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      width={360}
      title={t('record.totp.qrTitle', { title })}
    >
      <div style={{ textAlign: 'center' }}>
        <p style={{ fontSize: 12, color: '#E0663B', marginBottom: 12 }}>
          {t('record.totp.qrWarning')}
        </p>
        {renderQrBody()}
        <p style={{ fontSize: 12, color: '#5B6480', marginTop: 12, marginBottom: 0 }}>
          {t('record.totp.qrHint')}
        </p>
      </div>
    </Modal>
  )
}

export default TotpQrModal
